import jalaali from "jalaali-js";

function gregorianToJalali(date) {
  try {
    date = date.split(' ')[0];
    const year = parseInt(date.split('-')[0]);
    const month = parseInt(date.split('-')[1]);
    const day = parseInt(date.split('-')[2]);

    const new_date = jalaali.toJalaali(year, month, day);
    const formattedDate = `${new_date.jd}-${new_date.jm}-${new_date.jy}`;
    return formattedDate;
  } catch (error) {
    return date;
  }

};

export default gregorianToJalali;